<template>
  <span class="mb-4">
    <span :class="['mr-2', product == 'KVKK' ? 'mt-2' : '']" v-if="!onlyIcon">{{ product }}</span>
    <img v-if="product != 'PLATFORM' && product != 'RISK'" v-b-tooltip.hover :title="product" :class="['mr-2 ', product == 'KVKK' ? 'mt-2' : '']" :src="icon" width="22" />
    <i v-else class="iconoir-cube-hole mt-2 text-warning font-size-16" v-b-tooltip.hover :title="product"></i>
  </span>
</template>

<script>
export default {
  props: ["product", "onlyIcon"],

  computed: {
    icon() {
      if (this.product == "KVKK") {
        return "/icons/kvkk-active.svg";
      }
      if (this.product == "GDPR") {
        return "/icons/gdpr-active.svg";
      }
      if (this.product == "DDO") {
        return "/icons/ddo-active.svg";
      }
      if (this.product == "BGYS") {
        return "/icons/bgys-active.svg";
      }
    },
  },
};
</script>
